<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <h3>Software List </h3>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" title="Edit" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#softwarelist">
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                            <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                                <button type="button" title="Delete" data-bs-toggle="modal" data-bs-target="#deletesoftwarelist" (click)="deleteOpenModal()">
                                    <span><i class="ri-delete-bin-5-line"></i></span>
                                </button>
                            </div>
                            <div>
                                <button type="button" title="Create" (click)="createOpenModal()" data-bs-toggle="modal" data-bs-target="#softwarelist" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ag-grid-angular
                        style="height: calc(100vh - 120px) !important;" 
                        class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10>
                   </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>

<!-- Create new Timesheet -->
<div class="modal fade bd-example-modal-lg" id="softwarelist" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="softwarelistForm">
                <div class="modal-header">
                    <h5 class="modal-title">Create Software List </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <!-- <div class="input">
                        <div class="input-item">
                            <input formControlName="id" type="text" >
                            <label class="floating-label">Id</label>
                            <i class="ri-hashtag"></i>
                        </div>
                    </div>
                   -->
                    <div class="input">
                        <div  class="input-item">
                            <input formControlName="softwareName" type="text" required>
                            <label class="floating-label">Software Name</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                        <mat-error *ngIf="f.softwareName.touched && f.softwareName.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.softwareName.errors.required">Software Name is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="licenseNo" type="text" required>
                            <label for="description" class="floating-label">License No</label>
                            <i class="ri-file-list-line"></i>
                        </div>
                        <mat-error *ngIf="f.licenseNo.touched && f.licenseNo.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.licenseNo.errors.required">License No is required</mat-error>
                            <mat-error *ngIf="f.licenseNo.errors.pattern">License No should be numeric only</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="licenseInstallation" type="date" required>
                            <label for="licenseInstallation" class="floating-label">License Installation</label>
                            <i class="ri-calendar-check-line"></i>
                        </div>
                        <mat-error *ngIf="f.licenseInstallation.touched && f.licenseInstallation.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.licenseInstallation.errors.required">License Installation Date is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="licenseRenewalEndDate" type="date" required>
                            <label for="licenseRenewalEndDate" class="floating-label">License Renewal Date</label>
                            <i class="ri-calendar-check-line"></i>
                        </div>
                        <mat-error *ngIf="f.licenseRenewalEndDate.touched && f.licenseRenewalEndDate.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.licenseRenewalEndDate.errors.required">License Renewal Date is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="licenseExpiry" type="date" required>
                            <label for="licenseExpiry" class="floating-label">License Expiry</label>
                            <i class="ri-calendar-check-line"></i>
                        </div>
                        <mat-error *ngIf="f.licenseExpiry.touched && f.licenseExpiry.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.licenseExpiry.errors.required">License Expiry is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input  type="file" (change)="onFileChanged($event)" placeholder="Attachment" required>
                            <label for="attachment" class="floating-label"></label>
                            <i class="ri-calendar-check-line"></i>
                        </div>
                    </div>
                    <div *ngFor="let item of slattachment">
                        <table style="border: 1px dotted blue; border-radius: 10px">
                          <tbody>
                            <tr>
                              <td>
                                <span>{{ item }}</span>
                              </td>
                              <td>
                                <div class="delete">
                                  <a href="url"></a>
                                  <button
                                    type="button"
                                    (click)="
                                    downloadslApplicationsattachments(item)
                                    "
                                  >
                                    <span
                                      ><i class="ri-download-cloud-fill"></i
                                    ></span>
                                  </button>
                                </div>
                              </td>
                              <td>
                                <div class="delete">
                                  <button
                                    type="button"
                                    (click)="
                                      deleteslApplicationsattachments(item)
                                    "
                                  >
                                    <span
                                      ><i class="ri-delete-bin-5-line"></i
                                    ></span>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createSoftware()" [disabled]="!softwarelistForm.valid">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateSoftware()" [disabled]="!softwarelistForm.valid">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>


<!-- Delete an item -->
<div class="modal fade" id="deletesoftwarelist" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteTimesheet" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteTimesheetList()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div>